import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children, allowedRoles }) {
  const token = localStorage.getItem("token");
  const userStr = localStorage.getItem("user");
  
  let user = null;
  try {
    user = userStr ? JSON.parse(userStr) : null;
  } catch (e) {
    console.error("Error parsing user from localStorage:", e);
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    return <Navigate to="/login" />;
  }

  if (!token || !user) {
    console.warn("ProtectedRoute: No token or user, redirecting to login");
    return <Navigate to="/login" />;
  }

  if (allowedRoles && allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    console.warn(`ProtectedRoute: User role '${user.role}' not in allowed roles:`, allowedRoles);
    return <Navigate to="/dashboard" />;
  }

  return children;
}
